<template>
  <div style="padding-top: 3px; padding-left: 0px;">
    <div id="shiftstatus">
      <h1 style="color: #000">Cash Box {{tester}}</h1><hr>
      <table align="center" style="width: 80%; text-align: left;">
        <tr><td>B1000 : </td><td>{{this.B1000}}</td></tr>
        <tr><td>B500 : </td><td>{{this.B1000}}</td></tr>
        <tr><td>B100 : </td><td>{{this.B100}}</td></tr>
        <tr><td>B50 : </td><td>{{this.B50}}</td></tr>
        <tr><td>B20 : </td><td>{{this.B20}}</td></tr>
        <tr><td>C10 : </td><td>{{this.C10}}</td></tr>
        <tr><td>C5 : </td><td>{{this.C5}}</td></tr>
        <tr><td>C2 : </td><td>{{this.C2}}</td></tr>
        <tr><td>C1 : </td><td>{{this.C1}}</td></tr>
        <tr><td>C050 : </td><td>{{this.C050}}</td></tr>
        <tr><td>C025 : </td><td>{{this.C025}}</td></tr>
        <tr><td>Amount : </td><td>{{this.amount}}</td></tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import $ from "jquery";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Swal from "sweetalert2";
import api from "../../service/services";
export default {
  props: {
    tester: '',
  },
  data() {
    return {
    S_shift_uuid: '',
    S_open_at: '',
    S_shift_status: '',
    amount: '',
    B1000: '',
    B500: '',
    B100: '',
    B50: '',
    B20: '',
    C10: '',
    C5: '',
    C2: '',
    C1: '',
    C050: '',
    C025: '',
    };
  },
  computed: {
    ...mapState([
      "lang",
      "UUID",
      "accessToken",
      "Mode",
      "Type",
      "AmountPayment",
      "AuthenType",
      "StatusQrcode",
    ]),
    ...mapMutations(["onMessageWs"])
  },
  methods: {
    ShowShiftStatus () {
      const header = {
        headers: {
          'x-access-token': this.$store.state.accessToken
        }
      }
      api.shitfStatus(
        header,
        result => {
          console.log(result)
          this.S_shift_uuid = result.shift_uuid;
          this.S_open_at = result.open_at;
          this.S_shift_status = result.shift_status;
          this.amount = result.amount;
          this.B1000 = result.payment[0].b1000;
          this.B500 = result.payment[0].b500;
          this.B100 = result.payment[0].b100;
          this.B50 = result.payment[0].b50;
          this.B20 = result.payment[0].b20;
          this.C10 = result.payment[0].c10;
          this.C5 = result.payment[0].c5;
          this.C2 = result.payment[0].c2;
          this.C1 = result.payment[0].c1;
          this.C050 = result.payment[0].c050;
          this.C025 = result.payment[0].c025;
          this.S_isLoading = false;
        },
        error => {
          Swal.fire({
              title: "Check Shift Status Error",
              text: error,
              type: "error",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Reconnect !"
          }).then(result => {
              if (result.value) {
                this.ShowShiftStatus();
              }
          });
        }
      );
    },
  },
  mounted() {
    this.ShowShiftStatus();
  }
};
</script>

<style>
  tr, td {
  border-bottom: 1px solid #ddd;
  font-size: 23px
}
</style>>



// WEBPACK FOOTER //
// src/components/modal/shiftstatus.vue